import { useEffect } from "react";

declare global {
  interface Window {
    dataLayer?: unknown[];
  }
}

export function DeferredAnalytics({ gaId }: { gaId: string }) {
  useEffect(() => {
    const load = () => {
      if (document.querySelector(`script[src*="googletagmanager.com/gtag/js?id=${gaId}"]`)) return;

      window.dataLayer = window.dataLayer ?? [];
      const gtag = (...args: unknown[]) => {
        window.dataLayer?.push(args);
      };
      (window as Window & { gtag?: typeof gtag }).gtag = gtag;
      gtag("js", new Date());
      gtag("config", gaId);

      const script = document.createElement("script");
      script.async = true;
      script.src = `https://www.googletagmanager.com/gtag/js?id=${gaId}`;
      document.head.appendChild(script);
    };

    if ("requestIdleCallback" in window) {
      const id = window.requestIdleCallback(load, { timeout: 3000 });
      return () => window.cancelIdleCallback(id);
    }

    const timer = window.setTimeout(load, 2500);
    return () => window.clearTimeout(timer);
  }, [gaId]);

  return null;
}
